import React from "react"
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Spinner,
} from "@heroui/react"
import { useNavigate } from "react-router-dom"
import EditIcon from "../Icons/EditIcon"
import classes from "./ArticlesTable.module.scss"

interface Props {
  categories: KnowladgebaseCategory[]
  loading: boolean
}

const ArticlesTable = (props: Props) => {
  const { categories, loading } = props

  const navigate = useNavigate()

  const getValue = (value: any) => {
    if (loading) {
      return <Spinner size="sm" />
    }
    return value
  }

  return (
    <Table isCompact>
      <TableHeader>
        <TableColumn>עריכה</TableColumn>
        <TableColumn>כותרת</TableColumn>
        <TableColumn>תיאור</TableColumn>
        <TableColumn>קישור</TableColumn>
        <TableColumn>אייקון</TableColumn>
      </TableHeader>
      <TableBody emptyContent={"No rows to display."}>
        {categories.map((category, index) => {
          return (
            <TableRow key={`${index}`} className={classes.tableRow}>
              <TableCell>
                <EditIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/category/edit/${category.id}`)}
                />
              </TableCell>
              <TableCell>{getValue(category.title)}</TableCell>
              <TableCell>{getValue(category.subtitle)}</TableCell>
              <TableCell>
                <a
                  href={`https://help.diodrive.co.il/category/${category.slug}`}
                >
                  {getValue(category.slug)}
                </a>
              </TableCell>
              <TableCell>{getValue(category.icon)}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
export default ArticlesTable
